import { faUserGroup } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex, SxProps, Text } from '@modusign/design-system';

import { ResourceRoleSubject } from '../../types';

interface ResourceRoleSubjectLabelProps extends SxProps {
  role: ResourceRoleSubject;
}

export default function ResourceRoleSubjectLabel({ role, sx }: ResourceRoleSubjectLabelProps) {
  if (role.subjectType === 'GROUP') {
    return (
      <Flex alignItems="center" gap="6px" sx={sx}>
        <FontAwesomeIcon color="#BABABA" icon={faUserGroup} size="sm" />
        <Text>{role.groupName}</Text>
      </Flex>
    );
  }

  return (
    <Flex flexDirection="column" sx={sx}>
      <Text>{role.memberName}</Text>
      <Text color="textNeutralVeryLight" fontSize="xs">
        {role.memberEmail}
      </Text>
    </Flex>
  );
}
